module.exports = __webpack_public_path__ + "static/professionalPhoto-c5b6d327af6354d23f48a414d25f465b.jpg";